import { render, staticRenderFns } from "./NuevoProveedor.vue?vue&type=template&id=a1c51cf2&scoped=true"
import script from "./NuevoProveedor.vue?vue&type=script&lang=js"
export * from "./NuevoProveedor.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "spinkit/spinkit.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./NuevoProveedor.vue?vue&type=style&index=2&id=a1c51cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c51cf2",
  null
  
)

export default component.exports